import * as React from 'react'

import { Text, TextName } from 'sdk'

import arrow from './assets/arrow.svg'

import classes from './style.module.scss'

export interface SolutionsGridCardProps {
  logo: string
  bg: string
  description: string
  onClick?: () => void
  className?: string
}

export const SolutionsGridCard: React.FC<SolutionsGridCardProps> = ({
  logo,
  bg,
  description,
  onClick,
  className,
}) => {
  return (
    <div
      onClick={onClick}
      className={`${classes.card} ${className || ''}`}
      style={{ backgroundImage: `url(${bg})` }}
    >
      <img
        src={arrow}
        alt="arrow"
        width={24}
        height={24}
        className={classes.arrow}
      />

      <img
        className={classes.logo}
        src={logo}
        width={280}
        height={51}
        alt="logo"
      />

      <Text type={TextName.Text}>
        {description}
      </Text>
    </div>
  )
}
